import { render } from "./Arena.vue?vue&type=template&id=109e267a"
import script from "./Arena.vue?vue&type=script&lang=js"
export * from "./Arena.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/buildings/Arena.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "109e267a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('109e267a', __exports__)) {
    api.reload('109e267a', __exports__)
  }
  
  module.hot.accept("./Arena.vue?vue&type=template&id=109e267a", () => {
    api.rerender('109e267a', render)
  })

}


export default __exports__